
      document.addEventListener('DOMContentLoaded', function () {
        var customShipping = document.getElementById('custom-shipping');
        customShipping.style.display = 'block';
      });

/* RECHARGE AFTER ADD TO CART */ 
      const addToCartQtyButtons = document.querySelectorAll('.quantity__button');
      addToCartQtyButtons.forEach((button) => {
        button.addEventListener('click', function (event) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      });

 /* END RECHARGE AFTER ADD TO CART */ 

 /* RECHARGE AFTER CLICK ON ICON REMOVE */ 
      const DeleteCartButtons = document.querySelectorAll('.button--tertiary');
      DeleteCartButtons.forEach((button) => {
        button.addEventListener('click', function (event) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      });


 /* END RECHARGE AFTER CLICK ON ICON REMOVE */ 


 /* RECHARGE AFTER CLICK ON ADD TO CART BUTTON */ 
      const AddCartButtonsProducto = document.querySelectorAll('.product-form__submit');
      AddCartButtonsProducto.forEach((button) => {
        button.addEventListener('click', function (event) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      });
 /* END RECHARGE AFTER CLICK ON ADD TO CART BUTTON */ 

 /* SLIDESHOW MEDIA LINKED */ 
        const sliderItems = document.querySelectorAll('slideshow-component [id^="Slide-"]');
        sliderItems.forEach((item) => {
        let slideLink = item.dataset.link;
        item.addEventListener('click', () => {
          setTimeout(() => (location.href = slideLink), 0);
        });
      });
 
 /*  END SLIDESHOW MEDIA LINKED */ 